import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef, useId } from 'react';
import { DropdownGroupContextProvider } from '../../contexts/group-context.mjs';
import { DropdownMenuGroup } from '../../patched-dropdown/Dropdown.mjs';
import { dropdownGroup } from '../../shared/styles/group.vanilla.mjs';

const DropdownGroup = forwardRef(
  ({ className: classNameFromProps, title, ...props }, forwardedRef) => {
    const groupId = useId();
    const className = classNames(dropdownGroup, classNameFromProps);
    return /* @__PURE__ */ jsxs(DropdownGroupContextProvider, { id: groupId, children: [
      title,
      /* @__PURE__ */ jsx(
        DropdownMenuGroup,
        {
          "aria-labelledby": groupId,
          className,
          ref: forwardedRef,
          ...props
        }
      )
    ] });
  }
);

export { DropdownGroup };
//# sourceMappingURL=Group.mjs.map
